export const TABLE_OPTIONS = [
  { value: "Designations - org_designations", id: "org_designations" },
  { value: "Skills - org_skills", id: "org_skills" },
  { value: "Departments - org_departments", id: "org_departments" },
  { value: "Grade Levels - org_grade_levels", id: "org_grade_levels" },
  { value: "Divisions - org_divisions", id: "org_divisions" },
  { value: "Cost Centers - org_cost_centers", id: "org_cost_centers" },
  { value: "Work Locations - org_work_locations", id: "org_work_locations" },
  { value: "User Roles - org_roles", id: "org_roles" },
  { value: "States - org_states", id: "org_states" },
  { value: "Cities - org_cities - (Map correct State Id)", id: "org_cities" },
  { value: "Employee Data - emp_master", id: "emp_master" },
  { value: "Company Assets - org_assets", id: "org_assets" },
  { value: "Company Leave Types - org_leave_types", id: "org_leave_types" },
  { value: "Company Calendar Categories - org_calendar_categories", id: "org_calendar_categories" },
  { value: "Company Calendar Events - org_calendar_events", id: "org_calendar_events" },
  { value: "Products / Systems - fsm_products_services", id: "fsm_products_services" },
  { value: "Product Vendors - ims_product_vendors", id: "ims_product_vendors" },
  { value: "Product Catalog - ims_product_catalog", id: "ims_product_catalog" },
  { value: "Customer Data - crm_customer_master", id: "crm_customer_master" },
  { value: "Customer Contacts Details - crm_customer_contact_info", id: "crm_customer_contact_info" },
  { value: "Customer Tax Details - crm_customer_tax_info", id: "crm_customer_tax_info" }
];

export const ACCEPTED_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];
